module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('b-breadcrumb', {
    staticStyle: {
      "background-color": "#002b4954 !important",
      "padding": "0.45rem 1rem !important",
      "margin-bottom": "3px !important"
    }
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_c('i', {
    class: _vm.iconId
  }), _vm._v("\n        " + _vm._s(_vm.jobSeriesBanner) + "\n      ")]), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.bannerClientName))]), _vm._v(" "), _c('b-breadcrumb-item', {
    on: {
      "click": _vm.loadSummaryDoc
    }
  }, [_c('b-badge', {
    staticStyle: {
      "font-size": "100%"
    }
  }, [_vm._v("\n          Summary & Documents")])], 1), _vm._v(" "), (_vm.trackingId != '') ? _c('b-breadcrumb-item', {
    on: {
      "click": _vm.getShipmentSubscription
    }
  }, [_c('b-badge', {
    staticStyle: {
      "font-size": "100%"
    }
  }, [_vm._v("Tracking Link : " + _vm._s(_vm.trackingId))])], 1) : _vm._e(), _vm._v(" "), (_vm.trackingId == '') ? _c('b-breadcrumb-item', [_c('b-badge', {
    staticStyle: {
      "font-size": "100%"
    }
  }, [_vm._v("\n           Shipping line not linked with Subscription" + _vm._s(_vm.brf_id) + "\n         ")])], 1) : _vm._e(), _vm._v(" "), (_vm.brf_id) ? _c('BRFCard', {
    attrs: {
      "BRFDetails": null,
      "prbr_id": Number(_vm.brf_id)
    }
  }) : _vm._e(), _vm._v(" "), _c('Add-Message', {
    staticClass: "ml-auto",
    attrs: {
      "fk_all_module_id": _vm.allModuleIdBanner
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.jobSeriesBanner
    }
  }, [(_vm.allModuleIdBanner && _vm.showSummary == true) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.allModuleIdBanner,
      "JOBSERIES": _vm.jobSeriesBanner
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31e88d92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/trackingBannerComponent.vue
// module id = 2502
// module chunks = 0